export const TAX_IDENTIFIER_PLACEHOLDER = 'XXX-XX-XXXX'

export function isSsnIdentifier(isSsn) {
  return isSsn !== false
}

export function getTaxIdentifierLabel(isSsn) {
  return isSsnIdentifier(isSsn) ? 'SSN' : 'ITIN'
}

export function getTaxIdentifierActionLabel(isSsn) {
  return isSsnIdentifier(isSsn) ? "Associate don't have an SSN" : 'Associate have an SSN'
}

export function normalizeTaxIdentifier(value) {
  return value ? value.replace(/\D/g, '') : value
}

export function validateTaxIdentifier(value, isSsn) {
  const normalizedValue = normalizeTaxIdentifier(value)
  const isSsnMode = isSsnIdentifier(isSsn)

  if (!normalizedValue) {
    return null
  }

  if (normalizedValue.length !== 9) {
    return `Enter a valid ${getTaxIdentifierLabel(isSsnMode)} in ${TAX_IDENTIFIER_PLACEHOLDER} format.`
  }

  if (!isSsnMode && normalizedValue[0] !== '9') {
    return 'ITIN must start with 9.'
  }

  return null
}

export function createTaxIdentifierRule(getIsSsn) {
  return {
    validator: (_, value, callback) => {
      const validationMessage = validateTaxIdentifier(value, getIsSsn())

      if (validationMessage) {
        callback(new Error(validationMessage))
        return
      }

      callback()
    },
    trigger: 'change'
  }
}
